import { TextInput, Button, Text } from "grommet";
import { dropboxSharing } from "../api";
import React, { useState } from "react";
import { useAuth } from "../context";

const DropboxSharingSection = ({ isInternal, isSharing }) => {
    const [folderName, setFolderName] = useState('');
    const [sharingStatus, setSharingStatus] = useState('');
    const { tokens } = useAuth();

    return (
        <>
            {isInternal && isSharing && (
                <>
                    <Text>Enter the folder name to share:</Text>

                    <TextInput id="q" name="q" value={folderName} onChange={event => setFolderName(event.target.value)} />
                    <Button alignSelf='center' style={{ margin: '1rem 5rem', borderColor: 'white' }} label="Share" onClick={() => {
                        setSharingStatus('Sharing... Please don\'t close the page. It\'ll take about 2 mins.');
                        dropboxSharing(tokens?.idToken, folderName).then((res) => {
                            setSharingStatus(res);
                        });
                    }} />
                    <Text>{sharingStatus}</Text>
                </>
            )}
        </>
    )
};

export { DropboxSharingSection }